define('app/sf/last/sf-last-filter',[],function () {
	return function lastFilter(input) {
		if (angular.isArray(input)) {
			if (length) {
				return input[input.length - 1];
			}
			else {
				return;
			}
		}
		return input;
	};
});
